module.exports = __webpack_public_path__ + "static/moonlitNightBeginningArranged-3e895ef3d1a1c87620c8562186788ca1.mp3";